// src/client.tsx
import { hydrateRoot } from 'react-dom/client';
import { createRouter } from './router';
import { RouterClient } from '@tanstack/react-router/ssr/client';

const router = createRouter();

hydrateRoot(document, <RouterClient router={router} />);